(function () {
    'use strict';

    angular
        .module('elogbooks.common.files')
        .controller('RiskwiseFilesIntegrationDetailsController', RiskwiseFilesIntegrationDetailsController);

    RiskwiseFilesIntegrationDetailsController.$inject = [
        '$uibModalInstance',
        'requestDataFactory',
        'apiClient',
        'messenger',
        'file',
        'actionResponse',
        'integrationDocSystem',
        'integrationDocCats',
        '$scope',
        '$timeout'
    ];

    function RiskwiseFilesIntegrationDetailsController (
        $uibModalInstance,
        requestDataFactory,
        apiClient,
        messenger,
        file,
        actionResponse,
        integrationDocSystem,
        integrationDocCats,
        $scope,
        $timeout
    ) {
        var vm = this;
        vm.file = file;
        vm.actionResponse = actionResponse;
        vm.integrationDocSystem = integrationDocSystem;
        vm.integrationDocCats = integrationDocCats;
        vm.data = angular.extend({}, requestDataFactory.createRequest(), {
            integration: {'riskwise': null},
            _links: {
                'action': actionResponse._links.self,
                'file': file._links.self
            }
        });

        vm.create = createAction;
        vm.cancel = cancelAction;
        vm.resetIntegrationDoc = resetIntegrationDoc;
        vm.resetIntegrationChild = resetIntegrationChild;

        // Initialize elogbooks-select models for static data
        vm.integrationDocCatModel = {
            staticData: vm.integrationDocCats,
            selected: null,
            required: true,
            disabled: false,
            // Improve usability for long RiskWise document type names
            wide: true,
            tooltip: true,
            onSelect: function() {
                vm.resetIntegrationChild();
                // Update second dropdown with selected category data
                vm.integrationDocTypeModel.staticData = vm.integrationDocCatModel.selected ?
                    vm.integrationDocCats[vm.integrationDocCatModel.selected.href] : null;
                vm.integrationDocTypeModel.selected = null;
            },
            onRemove: function() {
                vm.resetIntegrationChild();
                vm.integrationDocTypeModel.staticData = null;
                vm.integrationDocTypeModel.selected = null;
            }
        };

        vm.integrationDocTypeModel = {
            staticData: null,
            selected: null,
            required: true,
            disabled: false,
            wide: true,
            tooltip: true,
            onSelect: function() {
                if (vm.integrationDocTypeModel.selected) {
                    vm.data.integration[vm.integrationDocSystem] = vm.integrationDocTypeModel.selected.href;
                }
            },
            onRemove: function() {
                vm.data.integration[vm.integrationDocSystem] = null;
            }
        };

        // Initialize skip integration type
        vm.skipIntegrationType = false;

        function createAction () {
            // Clean up skipped integrations before submitting
            if (vm.skipIntegrationType && vm.data.integration) {
                delete vm.data.integration[vm.integrationDocSystem];
            }

            apiClient.create(vm.file.getLink('integrate'), vm.data).then(function (response) {
                if (response) {
                    $uibModalInstance.close();
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function cancelAction() {
            $uibModalInstance.dismiss();
        }

        function resetIntegrationDoc(type) {
            // Use $timeout to ensure the checkbox model is updated before we check its value
            $timeout(function() {
                var isSkipped = vm.skipIntegrationType;

                // Only handle UI state - payload cleanup would happen at submit time if needed
                vm.integrationDocCatModel.disabled = isSkipped;
                vm.integrationDocTypeModel.disabled = isSkipped;
                vm.integrationDocCatModel.required = !isSkipped;
                vm.integrationDocTypeModel.required = !isSkipped;

                if (isSkipped) {
                    vm.integrationDocCatModel.selected = null;
                    vm.integrationDocTypeModel.selected = null;
                    vm.integrationDocTypeModel.staticData = null;
                }
            });
        }

        function resetIntegrationChild() {
            vm.data.integration[vm.integrationDocSystem] = null;
        }
    }
})();
